import { classNames } from "components/utils";
import React from "react";

export interface FlatCardProps {
  children?: React.ReactNode;
  className?: string;
  noBorder?: boolean;
  noBackground?: boolean;
  isLoading?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onClick?: () => void;
  style?: React.CSSProperties;
}

const FlatCard: React.FC<FlatCardProps> = (props) => (
  <div
    style={props.style}
    className={classNames(
      "dark:text-secondary rounded-md w-full p-4",
      props.noBackground ? "" : "bg-primaryBg",
      props.className ?? "",
      props.noBorder ? "" : "border border-zinc-800",
      props.isLoading ? "animated-border-div on" : "",
    )}
    onMouseEnter={props.onMouseEnter}
    onMouseLeave={props.onMouseLeave}
    onClick={props.onClick}
  >
    <div className="w-full">{props.children}</div>
  </div>
);

export default FlatCard;
